module.exports = __webpack_public_path__ + "img/recommed-img5.8fdc10d5.jpg";